export default __webpack_public_path__ + "static/media/users.fdec99ff.svg";